import styled from 'styled-components';

export const ViewContainer = styled.div`
  position: absolute;
  top: calc(50% - 18px);
  left: calc(50% - 18px);
`;
export const WonoloSpinner = styled.img`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    animation:spin 4s cubic-bezier(0, 1.22, 0.68, 1.13) infinite;
  }
  
  @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
  @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
  @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
`;
